<div class="card">
    <app-header titulo="Cadastro de depósitos" descricao="Cadastro dos depósitos utilizados no painel de insumos"></app-header>

    <p-table [value]="depositos">
        <ng-template pTemplate="header">
            <tr>
                <th>Instância</th>
                <th>Empresa</th>
                <th>Filial</th>
                <th>Depósito</th>
                <th>Tipo</th>
                <th>Padrão</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-deposito>
            <tr>
                <td>{{ deposito.instancia }}</td>
                <td>{{ deposito.cdEmpresaErp }}</td>
                <td>{{ deposito.cdFilialErp }}</td>
                <td>{{ deposito.cdDepositoErp }}</td>
                <td>{{ deposito.cdTipoDep }}</td>
                <td>{{ deposito.fgPadrao }}</td>
                <td><a [routerLink]="['editar', deposito.id]"><p-button icon="pi pi-arrow-up-right" severity="primary" class="m-1" aria-label="Acessar"></p-button></a></td>
            </tr>
        </ng-template>
    </p-table>
</div>